import { render, staticRenderFns } from "./DecimalEditor.vue?vue&type=template&id=0ebb106a"
import script from "./DecimalEditor.vue?vue&type=script&lang=js"
export * from "./DecimalEditor.vue?vue&type=script&lang=js"
import style0 from "./DecimalEditor.vue?vue&type=style&index=0&id=0ebb106a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports